export const strict = false;
